import React from "react";
import { useForm } from "react-hook-form";
import TextField from "../../Reusable/TextInput";
import Button from "../../Reusable/Button";
import Modal from "../../Reusable/Modal";
// @ts-ignore
import { tw } from "@careinfo/tailwind";
import usePostHook from "../../../customHooks/usePostHook";
import APIS from "../../../constant/Endpoint";
import { yupResolver } from "@hookform/resolvers/yup";
import { AddContactGroupForm } from "../../../utils/validationSchemas";

const AddContactGroupModal = ({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (val: boolean) => void }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
  } = useForm({
    resolver : yupResolver(AddContactGroupForm)
  });

  const { mutateAsync, isPostLoading } = usePostHook({ queryKey: ["contact-groups"] });

  const handleCreate = async (values: any) => {
    const url = APIS.CONTACT_GROUP;
    const formData = { ...values };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        setIsOpen(false);
        reset();
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} title="Add Contact Group List">
      <div className={tw`flex flex-col items-center w-[600px]`}>
        <form onSubmit={handleSubmit(handleCreate)} className={tw`space-y-4 mt-4 w-full`}>
          <div>
            <TextField
              label={
                <div className={tw`block text-sm font-medium mb-1`}>
                  Name <span className={tw`text-red-500`}>*</span>
                </div>
              }
              placeholder="Enter group name"
              register={register("name")}
              errors={errors?.name}
            />
          </div>

          <div className={tw`flex justify-center items-center gap-4 pt-2`}>
            <div className={tw`px-2 py-2 text-sm w-[100px]`}>
              <Button
                label="Cancel"
                onClick={() => setIsOpen(false)}
                variant="secondary"
                type="button"
              />
            </div>
            <div className={tw`px-2 py-2 text-sm w-[100px]`}>
              <Button label="Add" type="submit" isLoading={isPostLoading} />
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default AddContactGroupModal;
